// extracted by mini-css-extract-plugin
module.exports = {"preview":"Color_preview__2Tqfw","invalid":"Color_invalid__33Ckj"};